module.exports = __webpack_public_path__ + "static/media/fk.bbd2971f.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/fk.svg
// module id = 2089
// module chunks = 0